import { digObject, generateID, toggleArray } from '@domain-group/javascript-utils'

import { useForm } from '@domain-group/react-hooks'

import usePublication from '@hooks/usePublication'

import defaultState, { requiredFields } from '@models/publicationKeyContact'

const preparePublication = (contactParams, publication, action) => {
  const keyContacts = digObject(publication, 'options.key_contacts', [])

  const updatedKeyContact = { ...contactParams, id: contactParams.id || generateID() }

  const toggleOptions = action === 'delete' ? { deepCompare: true } : { useObjectKey: 'id' }

  const updatedKeyContacts = toggleArray(keyContacts, updatedKeyContact, toggleOptions)

  return {
    id: publication.id,
    options: { key_contacts: updatedKeyContacts },
  }
}

export function usePublicationKeyContactForm(keyContact = {}){
  const keyContactForm = useForm(defaultState, { entity: keyContact, requiredFields }, [keyContact.id])

  return {
    ...keyContactForm,
  }
}

const useCreateOrEditPublicationKeyContactModal = (params) => {
  const { keyContact, publication: initPublication } = params

  const {
    callbacks: { updatePublication },
    publication,
    updating,
  } = usePublication(initPublication)

  const {
    entityState,
    errors,
    handlers,
    saveEnabled,
  } = usePublicationKeyContactForm(keyContact)

  return (
    {
      callbacks: {
        preparePublication: action => preparePublication(entityState, publication, action),
      },
      entityState,
      errors,
      handlers,
      saveEnabled,
      updateFn: updatePublication,
      updating,
    }
  )
}

export default useCreateOrEditPublicationKeyContactModal
